import { render } from "./Schoolyears.vue?vue&type=template&id=23296004"
import script from "./Schoolyears.vue?vue&type=script&lang=js"
export * from "./Schoolyears.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__